import React from 'react';
export var TabBarContext = React.createContext({
  onTabInteraction: function onTabInteraction(evt) {},
  registerTab: function registerTab(tab) {},
  unregisterTab: function unregisterTab(tab) {},
  indicatorTransition: 'slide'
});